var map = {
	"./Albania.svg": 6159,
	"./Algeria.svg": 458,
	"./Andorra.svg": 8792,
	"./Australia.svg": 8169,
	"./Austria.svg": 1942,
	"./Bahamas.svg": 2476,
	"./Bangladesh.svg": 5494,
	"./Belgium.svg": 9160,
	"./Belize.svg": 9100,
	"./Brazil.svg": 8627,
	"./Bulgaria.svg": 1970,
	"./Cambodia.svg": 6687,
	"./Canada.svg": 4363,
	"./Chile.svg": 8608,
	"./China.svg": 9318,
	"./Croatia.svg": 3540,
	"./Cyprus.svg": 8775,
	"./Czech Republic.svg": 4658,
	"./Denmark.svg": 9785,
	"./Estonia.svg": 690,
	"./Finland.svg": 1235,
	"./France.svg": 7560,
	"./Georgia.svg": 9171,
	"./Germany.svg": 2188,
	"./Honduras.svg": 7121,
	"./Hong Kong.svg": 5814,
	"./Hungary.svg": 7013,
	"./Iceland.svg": 5405,
	"./India.svg": 6542,
	"./Indonesia.svg": 9561,
	"./Ireland.svg": 7634,
	"./Islamic Republic of Iran.svg": 9250,
	"./Israel.svg": 6249,
	"./Italy.svg": 5266,
	"./Japan.svg": 8879,
	"./Kazakhstan.svg": 4959,
	"./Latvia.svg": 8328,
	"./Lithuania.svg": 9390,
	"./Luxembourg.svg": 6821,
	"./Malaysia.svg": 4428,
	"./Maldives.svg": 1334,
	"./Mauritius.svg": 6814,
	"./Netherlands.svg": 2071,
	"./New Zealand.svg": 870,
	"./Norway.svg": 7191,
	"./Panama.svg": 9965,
	"./Philippines.svg": 7306,
	"./Poland.svg": 2833,
	"./Republic of Korea.svg": 170,
	"./Republic of Moldova.svg": 4820,
	"./Romania.svg": 3906,
	"./Russian Federation.svg": 6127,
	"./Seychelles.svg": 8536,
	"./Singapore.svg": 7133,
	"./South Africa.svg": 1478,
	"./Spain.svg": 8840,
	"./Sweden.svg": 6789,
	"./Switzerland.svg": 9248,
	"./Taiwan.svg": 6421,
	"./Thailand.svg": 9688,
	"./Turkey.svg": 2223,
	"./Ukraine.svg": 1076,
	"./United Arab Emirates.svg": 6816,
	"./United Kingdom.svg": 4247,
	"./United States.svg": 2326,
	"./Vietnam.svg": 7247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5044;